import React, { FC } from 'react';

import { Stack, StackProps } from '@mantine/core';

const ModalDescription: FC<
    StackProps & {
        children: React.ReactNode;
    }
> = ({ children = null, ...props }) => <Stack {...props}>{children}</Stack>;

export { ModalDescription };
